/*jshint esversion:6 */
import React from 'react';
import ATable from '../../common/table';

const TransactionTimelinesTable = (props) => {


    const columns = [{
        header: "S/N",
        width: 50,
        render: row => (<div>{props.paginatedCallBack(row.viewIndex) }</div>)
    },
    {
        header: "Dispute Region",
        accessor: "disputeRegion"
    },
    {
        header: "Dispute Category",
        accessor: "disputeCategory",
    },
    {
        header: "Wait Time (Hours)",
        accessor: "waitTime",
    },
    {
        header: "Valid Time (Hours)",
        accessor: "validTime",
    }
    ];
    return (
        <ATable
            className="-striped -highlight"
            tableData={props.transactionTimelines}
            columns={columns}
            onChange={props.onTableChange || null}
            manual
            {...props} />
    )
};

export default TransactionTimelinesTable;


// WEBPACK FOOTER //
// ./src/components/admin/transactionTimelines/transactionTimelinesTable.js